import axios from "axios";
// import store from "../store";

// 設定全域訪問的連結
//開發
//xios.defaults.baseURL = 'http://localhost:4526/dmsapi';
//打包
//axios.defaults.baseURL = '../dmsapi/';
axios.defaults.baseURL = '/api/';
 //axios.defaults.baseURL = 'http://3.228.238.227:8100/dmsapi/';

//axios.defaults.headers.common["authorization"] = `${store.state.tokenModule.token}`;

// axios 請求's 相關設定
axios.interceptors.request.use(
  (config) => {
    //console.log("攔截請求");
    // store.commit("SET_LOADING", true);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// axios 回應's 相關設定
axios.interceptors.response.use(
  (response) => {
    //console.log("攔截回應");
    // store.commit("SET_LOADING", false);
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.log(error);
          break;
        case 403:
          console.log(error);
          break;
        case 404:
          console.log(error);
          break;
        case 500:
          console.log(error);
          break;
        default:
          console.log(error);
          break;
      }
    }
    if(!window.navigator.onLine){
      alert("網路連線出現問題，請重新連線或重整網頁");
      return;
    }
    // store.commit("SET_LOADING", false);
    return Promise.reject(error.response);
  }
);

export default axios;
